<template>
  <el-dialog
    v-model="state.dialogVisible"
    title="New Prospect"
    width="45%"
    :before-close="closeDialog"
    destroy-on-close
  >
    <div>
      <el-form ref="form" :model="ruleForm" label-position="top" :rules="rules">
        <el-form-item label="Name" prop="name" class="w-full">
          <el-input v-model="ruleForm.name" placeholder="Enter Name" @keyup.enter="submit" />
        </el-form-item>
        <el-form-item label="Email" prop="email" class="w-full my-4">
          <el-input v-model="ruleForm.email" placeholder="Enter Email" @keyup.enter="submit" />
        </el-form-item>
        <el-form-item prop="phone" label="Phone">
          <SwdPhoneInput
            v-model="ruleForm.phone"
            default-country="US"
            :preferred-countries="['US']"
            placeholder="Enter Phone Number"
            :required="true"
            @keyup.enter="submit"
            :show-inline-error="false"
          />
        </el-form-item>
        <div class="pt-5 flex justify-end">
          <SwdButton primary main class="mr-2 w-28" @click="closeDialog">Close</SwdButton>
          <el-form-item class="w-28">
            <Button :disabled="isLoading" :full="true" :default-primary="true" text-btn="Send" @click="submit" />
          </el-form-item>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { useStore } from 'vuex'
import { reactive, watchEffect, ref } from 'vue'
import { rules } from '@/validationRules/modalNewLead.js'
import { sendLinkNewLead } from '@/api/vueQuery/fetch-send-link-new-lead'
import { useMutation, useQueryClient } from 'vue-query'
import { useAlert } from '@/utils/use-alert'
import { useRoute } from 'vue-router'
import SwdPhoneInput from '@/components/Global/SwdPhoneInput.vue'

export default {
  name: 'NewLeadModal',
  components: {
    SwdPhoneInput,
  },
  setup() {
    const store = useStore()
    const form = ref(null)
    const route = useRoute()
    const queryClient = useQueryClient()

    const { isLoading, mutateAsync: fetchSendLink, error } = useMutation(sendLinkNewLead)

    const ruleForm = reactive({
      name: '',
      email: '',
      phone: '',
    })

    const state = reactive({
      dialogVisible: false,
    })

    watchEffect(() => {
      state.dialogVisible = store.state.globalComponents.dialog.showDialog.newLead
    })

    const closeDialog = () => {
      store.commit('globalComponents/setShowModal', {
        destination: 'newLead',
        value: false,
      })
      ruleForm.name = ''
      ruleForm.email = ''
      ruleForm.phone = ''
    }
    let isSubmitting = false

    const submit = (e) => {
      if (isSubmitting) {
        return
      }
      isSubmitting = true
      e.preventDefault()
      form.value.validate(async (valid) => {
        if (valid) {
          try {
            const res = await fetchSendLink(ruleForm)
            if (!('error' in res)) {
              useAlert({
                title: 'Success',
                type: 'success',
                message: 'Link Sent Successfully.',
              })
              if (
                route.name === `${route.meta.type}/all-leads` ||
                route.name === `${route.meta.type}/active-leads` ||
                route.name === `${route.meta.type}/deactivated-leads`
              ) {
                queryClient.invalidateQueries(['householders-list'])
              }
              closeDialog()
            }
          } catch (error) {
            // Handle any errors during submission
          } finally {
            isSubmitting = false // Reset the flag
          }
        } else {
          isSubmitting = false // Reset the flag
          return false
        }
      })
    }

    return {
      state,
      closeDialog,
      ruleForm,
      form,
      rules,
      submit,
      isLoading,
      error,
    }
  },
}
</script>
